export default __webpack_public_path__ + "static/media/bars-regular-white.872d6f1f.svg";